
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.368 2.577a8.748 8.748 0 00-2.782 2.776.746.746 0 00-.068.11 8.75 8.75 0 000 9.074A8.749 8.749 0 0014.54 17.48a8.753 8.753 0 002.878-12.12 8.748 8.748 0 00-11.97-2.832.746.746 0 00-.08.049zm.34 1.58a7.249 7.249 0 00-1.55 1.55l2.474 2.476a3.825 3.825 0 011.55-1.55L5.707 4.156zM3.377 7.05a7.249 7.249 0 000 5.9l2.798-2.798a3.818 3.818 0 010-.304L3.378 7.05zm.78 7.242a7.248 7.248 0 001.55 1.55l2.475-2.474a3.827 3.827 0 01-1.55-1.55l-2.476 2.474zm2.891 2.33a7.25 7.25 0 005.902 0l-2.798-2.798a3.872 3.872 0 01-.304 0l-2.8 2.798zm7.244-.78a7.236 7.236 0 001.55-1.55l-2.476-2.474a3.829 3.829 0 01-1.55 1.55l2.476 2.475zm2.33-2.89a7.25 7.25 0 000-5.903l-2.8 2.798a3.875 3.875 0 010 .306l2.8 2.798zm-.78-7.245a7.24 7.24 0 00-1.55-1.55l-2.475 2.475a3.828 3.828 0 011.55 1.55l2.475-2.475zM12.95 3.378a7.248 7.248 0 00-5.902 0l2.799 2.798a3.833 3.833 0 01.305 0l2.798-2.798zm-2.586 4.324a2.327 2.327 0 10-.73 4.596 2.327 2.327 0 00.73-4.596z"}})])
          )
        }
      }
    